export const Periods = {
    Day: "Day",
    Month: "Month",
    Year: "Year",
};
